import React from "react";
import {Redirect} from "react-router-dom";

export default function NotFound() {
    return (
        <div className="NotFound text-center">
            <h3>Errore 404, pagina non trovata!</h3>
            <Redirect to="/"/>
        </div>
    );
}
